module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Regular.5810cdf5.otf";